import { Divider } from '@mui/material'
import { type $Table, type $Top } from 'element-domain/src/__generated/enhanced-model'

import { AttributeToggleSelector, ChildEntityToggleSelector } from '@salsita-ai/platform-project-sdk/react'
import { PropertyContainer } from '@salsita-ai/platform-project-sdk/ui'

interface AppearancePropertyPageProps {
  tableId: $Table['id']
  top: $Top
}

export default function AppearancePropertyPage({ top }: AppearancePropertyPageProps) {
  return (
    <PropertyContainer.Section title="Appearance">
      <Divider sx={{ my: 2.5 }} />

      <PropertyContainer.Group spacing="large">
        <PropertyContainer.Item title="Grooves">
          <AttributeToggleSelector entityId={top.id} instanceName="withGrooves" columnCount={2} />
        </PropertyContainer.Item>
        <PropertyContainer.Item title="Rounded Corners">
          <AttributeToggleSelector entityId={top.id} instanceName="withCornerRadius" columnCount={2} />
        </PropertyContainer.Item>

        <PropertyContainer.Item title="Apron">
          <ChildEntityToggleSelector entityId={top.id} instanceName="aprons" columnCount={2} />
        </PropertyContainer.Item>

        <PropertyContainer.Item title="Table Edge">
          <AttributeToggleSelector entityId={top.id} instanceName="edgeStyle" columnCount={3} />
        </PropertyContainer.Item>

        <PropertyContainer.Item title="Level of Distress">
          <AttributeToggleSelector entityId={top.id} instanceName="distressLevel" columnCount={3} />
        </PropertyContainer.Item>
      </PropertyContainer.Group>
    </PropertyContainer.Section>
  )
}
